import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import VideoPlayer from './VideoPlayer';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    '&[data-hidden="1"]': {
      display: 'none',
    },
  },
  statusBox: {
    margin: '5rem',
  },
}));

VideoWrapper.propTypes = {
  playbackUrl: PropTypes.string,
};
export default function VideoWrapper(props) {
  const classes = useStyles(props);
  const { IVSPlayer } = window;
  const { isPlayerSupported } = IVSPlayer;
  const [loading, setLoading] = useState(false);
  const player = useRef(null);
  const { playbackUrl } = props;

  useEffect(() => {
    const { ENDED, PLAYING, READY } = IVSPlayer.PlayerState;
    const { ERROR, TEXT_METADATA_CUE } = IVSPlayer.PlayerEventType;

    if (!isPlayerSupported) {
      console.warn('The current browser does not support the Amazon IVS player.');

      return;
    }

    const onStateChange = () => {
      const newState = player.current.getState();

      setLoading(newState !== PLAYING);
    };

    const onError = (err) => {
      console.warn('Player Event - ERROR:', err);
    };
    // const onCue = (cue) => {
    //   // const metadata = JSON.parse(cue.text);
    // };

    player.current = IVSPlayer.create();

    player.current.addEventListener(READY, onStateChange);
    player.current.addEventListener(PLAYING, onStateChange);
    player.current.addEventListener(ENDED, onStateChange);
    player.current.addEventListener(ERROR, onError);
    // player.current.addEventListener(TEXT_METADATA_CUE, onCue);
    setLoading(true);

    return () => {
      player.current.removeEventListener(READY, onStateChange);
      player.current.removeEventListener(PLAYING, onStateChange);
      player.current.removeEventListener(ENDED, onStateChange);
      player.current.removeEventListener(ERROR, onError);
      player.current.removeEventListener(TEXT_METADATA_CUE, () => {});
    };
    // eslint-disable-next-line
  }, [IVSPlayer, isPlayerSupported]);

  if (!isPlayerSupported) {
    return null;
  }

  return (
    <div className={classes.root}>
      {playbackUrl && (
        <VideoPlayer loading={loading} player={player.current} playbackUrl={playbackUrl} />
      )}
    </div>
  );
}
